import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

export const Section = styled.div`
  display: block;
  margin: 0 auto;
`;

export const ImageWrapper = styled.div`
  display: block;
  margin: 0 auto;
  width: 100%;
  max-height: 800px;
`;

type ImageProps = IThemeProps<{}>;
export const Image = styled.img<ImageProps>`
  position: relative;
  display: block;
  margin: 0 auto;
  overflow: hidden;

  background-color: ${(props: any) => props.theme.colors.white};
  border-color: ${(props: any) => props.theme.colors.white};
  border-style: solid;
  border-width: ${(props: any) => props.theme.borders.imageTile};
  box-shadow: ${(props: any) => props.theme.shadows.s200};

  width: 100%;
  height: auto;

  transition: all 0.25s ease-in;
`;

type DividerProps = IThemeProps<{}>;
export const Divider = styled.div<DividerProps>`
  display: block;
  margin: 0 auto;
  height: 3px;
  width: 100%;
  max-width: 200px;
  background-color: ${(props: any) => props.theme.colors.divider};
  margin-top: ${(props: any) => props.theme.spacing.desktop.s500}px;
`;

export const ImageQuestionWrap = styled.div`
  display: block;
  margin: 0 auto;
`;
